import getResource from "../infrastructure/getResource";
import { MethodRequest } from "../interfaces/fetch/methodRequest";
import { IParametersFetch } from "../interfaces/fetch/parametersFetch";
import { ResponseResult } from "../interfaces/fetch/responseResult";
import { TypeReturn } from "../interfaces/fetch/typeReturn";
import { CreateParameters } from "../interfaces/tinkoff/createParameters";
import { CreateResult } from "../interfaces/tinkoff/result/createResult";

/**
 * Создание заявки
 * @param createParameters - параметры для создания заявки
 * @returns 
 */
const create = async (createParameters: CreateParameters, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parametersFetch: IParametersFetch<string> = {
    url: url,// config.ServiceInternetAcquiring.Create,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(createParameters),
    typeReturn: TypeReturn.json,
    headers: headers,
  };

  const result: ResponseResult = await getResource(parametersFetch);
  return result.result as CreateResult;
};

/**
* Создание демо заявки
 * @param createParameters - параметры для создания заявки
 * @returns 
 */
const createDemo = async (createParameters: CreateParameters, url: string) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  const parametersFetch: IParametersFetch<string> = {
    url: url, // config.ServiceInternetAcquiring.CreateDemo,
    methodRequest: MethodRequest.POST,
    body: JSON.stringify(createParameters),
    typeReturn: TypeReturn.json,
    headers: headers,
  };

  const result: ResponseResult = await getResource(parametersFetch);
  return result.result as CreateResult;
};

export const TinkoffService = {
  create,
  createDemo
};